import React from "react";
import style from "css/landing.module.css";
import { ReactComponent as Arrow } from "asset/common/arrow.svg";
import { useMediaQuery } from "react-responsive";

function PartnerSwiperItem(props) {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });
  return (
    <div className={style.partner_swiper_item_wrap} ref={props.ref}>
      <div className={style.partner_swiper_header_wrap}>
        <div className={style.partner_swiper_index_wrap}>
          <div className={style.partner_swiper_index}>
            {props.index.toString().padStart(2, "0")}
          </div>
          <div className={style.partner_swiper_type}>{props.item.type}</div>
        </div>
        <div
          className={style.partner_swiper_more_wrap}
          style={{ display: "none" }}
        >
          <div className={style.partner_swiper_more_view_text}>More View</div>
          <Arrow fill={"#0a2cc4"} width="35px" height="35px" />
        </div>
      </div>

      {!isMobile && !isTablet ? (
        <div className={style.partner_list_grid}>
          {props.item.list && props.item.list.length > 0
            ? props.item.list.map((partner, index) => (
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}` + partner.img}
                  key={index}
                  alt="partner"
                />
              ))
            : null}
          <div className={style.partner_more}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      ) : (
        <img
          src={`${process.env.REACT_APP_CLIENT_URL}` + props.item.img_m}
          alt="partner"
        />
      )}
    </div>
  );
}

export default PartnerSwiperItem;
